<template>
    <div class="col-9 text-center align-items-center pt-5" :style="shown ? {} : { display: 'none' }" :class="shown ? 'show' : ''">
        <div class="error-icon mb-3"><span class="material-icons">error_outline</span></div>
        <h1 class="text-yellow">{{$t('item_not_recognized')}}</h1>
        <h3>{{$t('return_item')}}</h3>
    </div>
</template>
<script>
export default {
    props: [
        "shown"
    ],
    data () {
        return {
        }
    },
    mounted () {
    },
    created () {
    },
    computed: {
    },
    methods: {
    },
    watch: {
    }
}
</script>